import type Money from '@breeze-platform-ui/money';

export const phMoneyProps: Omit<React.ComponentProps<typeof Money>, 'value'> = {
  currency: 'PHP',
  symbolPosition: 'prefix',
  digitGroupingSeparator: ',',
  decimalSeparator: '.',
} as const;
